/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Weclapp_Time_Filter_Start_DateInputs */



/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Spaces_Weclapp_Time_Filter_Start_DateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_weclapp_time_filter_start_date = /** @type {((inputs?: Spaces_Weclapp_Time_Filter_Start_DateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Weclapp_Time_Filter_Start_DateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startdatum")
	return /** @type {LocalizedString} */ ("Start date")
});